import { ReactElement } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Icon, UserActionWrapper } from './subcomponents'
import { UserActionProps } from './typings'

const UserAction = ({
  handleUserDetail,
  handleNewUserSelect,
  handleDelete,
  handleAssign
}: UserActionProps): ReactElement => {
  return (
    <UserActionWrapper>
      {handleDelete && (
        <Icon variant="outline-light" onClick={handleDelete}>
          <FontAwesomeIcon
            icon={['far', 'trash-alt']}
            style={{ marginRight: 10 }}
          />
        </Icon>
      )}
      {handleUserDetail && (
        <Icon variant="outline-light" onClick={handleUserDetail}>
          <FontAwesomeIcon icon={['far', 'eye']} style={{ marginRight: 10 }} />
        </Icon>
      )}
      {handleNewUserSelect && (
        <Icon variant="outline-light" onClick={handleNewUserSelect}>
          <FontAwesomeIcon icon={['far', 'edit']} style={{ marginRight: 10 }} />
        </Icon>
      )}
      {handleAssign && (
        <Icon variant="outline-light" onClick={handleAssign}>
          <FontAwesomeIcon icon={['far', 'user']} style={{ marginRight: 10 }} />
        </Icon>
      )}
    </UserActionWrapper>
  )
}

export default UserAction
